'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import { SvgShare2 } from '@common/icon';
import { useState } from 'react';
import { CustomLink } from '@/app/_components/CustomLink';
import { SnsShareDrawer } from './SnsShareDrawer';
const GOOGLE_FORM_URL = 'https://forms.gle/mGg3xYe1KGuUXyZJ9';
export const SnsShareButton = () => {
  const $ = _c(6);
  const [isOpen, setIsOpen] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Button className="flex-1" asChild={true}><CustomLink href={GOOGLE_FORM_URL} target="_blank" className="flex items-center gap-8">구글 폼 입력하기</CustomLink></Button>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setIsOpen(true);
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <button type="button" className="flex-center" onClick={t1} aria-label={"\uACF5\uC720\uD558\uAE30"}><SvgShare2 /></button>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setIsOpen(false);
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== isOpen) {
    t4 = <div className="flex w-full items-center gap-16">{t0}{t2}<SnsShareDrawer opened={isOpen} onClose={t3} /></div>;
    $[4] = isOpen;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};